define('responsive-pitch-fx/lib/render/Dom',['require','exports','module','../helpers/domHelper','Responsive/vendor','Responsive/util/imageDensity','image-loader/image-loader','tether/tether','../helpers/cssClass','../enums/16x11'],function(require,exports,module){
	var pitchFxDataContainerTemplateClassName = "data-description",
		domHelper = require( '../helpers/domHelper' ),
		vendor = require( 'Responsive/vendor' ),
		imageDensity = require( 'Responsive/util/imageDensity' ),
		imageLoader = require( 'image-loader/image-loader' ),
        Tether = require('tether/tether'),
        cssClass = require( '../helpers/cssClass' );

	var regexPlayer = /\w+-(\w+)-(\w+)(@2x)?(\.\w+)/,
		regexLefty = /\s*lefty|$\s*/;

    function RenderDom(pitchLayer){
    	this.pitchLayer=pitchLayer;
    	this.scalers=pitchLayer.scalers;

        this.sizer = document.createElement('img');
        this.player = document.createElement('div');
        this.ballTemplate = document.createElement('div');
        this.container = document.createElement('div');
        this.pitchFxDataContainerTemplate = document.createElement('div');
        this.pitchFxDataItemDescriptionTemplate = document.createElement('div');
        this.pitchFxDataItemTemplate = document.createElement('span');

        this.sizer.className = cssClass("aspect-ratio");
        this.container.className = cssClass("dom");
        this.player.className = cssClass("player");
        this.player.style.opacity = 0;
        this.ballTemplate.className = cssClass("ball");
        this.pitchFxDataContainerTemplate.className = cssClass(pitchFxDataContainerTemplateClassName);
        this.pitchFxDataItemDescriptionTemplate.className = cssClass("data-item");
        this.sizer.src=this.getSizerURI();
        this.config = pitchLayer.config;

        if(this.pitchLayer.scalers.canvasDensity>=1){
	        this.player.style[vendor.transitionJS] = "opacity 300ms ease-in 0";
	    }

        // TODO : depth effect blur, for stadium bg
        // this.blur.height = 0;
        // this.blur.innerHTML = '<filter id="fieldBlur">'
        //     + '     <feGaussianBlur stdDeviation="3"/>'
        //     + '</filter>'

    }

    RenderDom.prototype={

        calculateDivBall : function (coord, offset, dim) {
            var coord_per = (coord - (offset / 2) - this.pitchLayer.scalers.fakeBallSize / 2) / this.pitchLayer.scalers[dim] * 100;
            return coord_per + '%';
        },
        drawBall : function(p, pt){
            var that=this,
                scalers=this.scalers,
                fsize = ( 70 / this.pitchLayer.scalers.base_width * this.scalers.fakeBallSize).toFixed(2),
                ballEl = this.ballTemplate.cloneNode(),
                pitchFxDataEl = this.pitchFxDataContainerTemplate.cloneNode(),
                font = 'bold ' + fsize + 'em ' + that.config.font,
                lineWidth = pt[4] || 0;

            ballEl.className += " " + cssClass("pitch-" + p.type);

            ballEl.style.top = this.calculateDivBall(pt[1], 0, 'height');
            ballEl.style.left = this.calculateDivBall(pt[0], lineWidth+scalers.fakeBallSize, 'width');
            ballEl.style.height = this.calculateDivBall(scalers.fakeBallSize * 2, -scalers.fakeBallSize, 'height');
            ballEl.style.width = this.calculateDivBall(scalers.fakeBallSize * 2, -scalers.fakeBallSize, 'width');
            ballEl.style.fontSize = fsize / scalers.canvasDensity + 'em';
            ballEl.style.fontFamily = that.config.font;

            if (p.num) {
                ballEl.setAttribute('data-pitch-num', p.num);
            }

            if (!this.pitchLayer.render.isCanvas || that.config.domBalls) {
                ballEl.style.backgroundColor = p.shader.ball;
                ballEl.style.backgroundSize = "150%";
                //ballEl.style.backgroundImage="radial-gradient(circle farthest-corner, " + color.replace(regexColor, colorShiftLight) +" 0%," + color +" 40%,"+ color.replace(regexColor, colorShift) +" 100%";
                ballEl.style.border = '1px solid ' + p.shader.ballStroke;
                ballEl.style.color = p.shader.text;
                ballEl.innerHTML = p.num || ""; // No number? Just show ball without it
            }

            // Draw Pitch Fx data for when ball is hovered/clicked
            if(that.config.hoverData) {
            addPitchFxDataLine("#" + p.num + " ", p.des);
            addPitchFxDataLine("Pitch Type: ", p.displayName ? p.displayName : '--');
            addPitchFxDataLine("Nasty Factor: ", p.nastyFactor ? p.nastyFactor : '--');
            addPitchFxDataLine("Release Speed: ", p.startSpeed ? p.startSpeed + " MPH" : '--');
            addPitchFxDataLine("Result Speed: ", p.endSpeed ? p.endSpeed + " MPH" : '--');
            addPitchFxDataLine("Break: ", (p.breaks.breakAngle == 0 || !p.breaks.breakAngle ? "--" : p.breaks.breakAngle + " degrees"));
            }

            if (p.num) {
                pitchFxDataEl.className = pitchFxDataEl.className + " " + cssClass("pitch-" + p.num);
            }

            // Show pitch data on hover
            if(that.config.hoverData) {
                ballEl.addEventListener('mouseenter', function (pitchDiv) {
                    var pitchNumber = pitchDiv.currentTarget.getAttribute('data-pitch-num');
                    var pitchData = document.querySelector('.'+cssClass("pitch-") + pitchNumber);
                    pitchData.style.visibility = 'visible';
                    pitchData.style.opacity = '0.8';
                    pitchData.style.zIndex = '9999';
                    // tracking.track_pitches_activity();
                });

                // Hide pitch data when your mouse leaves the divBall
                ballEl.addEventListener('mouseleave', function (pitchDiv) {
                    var pitchNumber = pitchDiv.currentTarget.getAttribute('data-pitch-num');
                    var pitchData = document.querySelector('.'+cssClass("pitch-") + pitchNumber);
                    pitchData.style.visibility = null;
                    pitchData.style.opacity = null;
                    pitchData.style.zIndex = null;
                });
            }

            domHelper.append(ballEl,pitchFxDataEl);
            domHelper.append(this.container,ballEl);

            if(that.config.hoverData) {
                /*
                 * Compute visible area between left/right scroll cards for each pitch. This way 'Tether' knows
                 * when the hover pitch fx div is out of view and adjusts its orientation accordingly
                 * (The contraints are set in constraints[{to}] - X1, Y1, X2, Y2)
                 */
                var leftCardCoords = (document.querySelector('.CardView-left')||this.pitchLayer.view).getBoundingClientRect();
                var rightCardCoords = (document.querySelector('.CardView-right')||this.pitchLayer.view).getBoundingClientRect();

            var bounds  = {
                top     : leftCardCoords.top,
                bottom  : rightCardCoords.bottom,
                left    : Math.min(leftCardCoords.right,rightCardCoords.left),
                right   : Math.max(leftCardCoords.right,rightCardCoords.left)

            };

                new Tether({
                    element: pitchFxDataEl,
                    target: ballEl,
                    attachment: 'bottom middle',
                    targetAttachment: 'top middle',
                    offset: '8px 0',
                    constraints: [
                        {
                            to: [leftCardCoords.right, leftCardCoords.top, rightCardCoords.left, rightCardCoords.bottom],
                            attachment: 'together',
                            pin: true
                        }
                    ]
                });
            }

            function addPitchFxDataLine(label, dataPoint) {
                var pitchFxDataItem = that.pitchFxDataItemDescriptionTemplate.cloneNode();
                var pitchFxData = that.pitchFxDataItemTemplate.cloneNode();
                pitchFxDataItem.innerHTML = label;
                pitchFxData.innerHTML = dataPoint;
                pitchFxDataItem.appendChild(pitchFxData);
                pitchFxDataEl.appendChild(pitchFxDataItem);
            }
        },
            // TODO: There's some clean up that's possible here
        drawBatter : function () {
            var that=this,
            	batterSrc = this.pitchLayer.atbat.getBatterImage(imageDensity.choose(this.pitchLayer.view || this.canvas_bg, 'iphone', 'ipad', 'ipad'));
            // console.log('drawBatter',batterSrc);
            imageLoader.load(batterSrc)
                .done(function (src) {
                    that.setPlayerImage(src);
                }).fail(function (src) {
                    that.setGenericPlayerImage(src);
                });
        },
        parseBatterHeight : function(height) {
			var b_height=((height || this.scalers.batterHeight)+"").split('-'),
				feet = parseFloat(b_height[0]) + (parseFloat(b_height[1])/ 12);

			return feet;
		},

        setPlayerImage : function (src) {
            var that = this,
            	scalers = this.scalers,
            	parent = this.pitchLayer.view,
            	isRighty = src.indexOf('RIGHT')!==-1,
                atbat = this.pitchLayer.atbat,
            	bHeight = scalers.batterScaling && ((this.parseBatterHeight(atbat.height || atbat.batterHeight)) / this.parseBatterHeight(scalers.batterScale)).toFixed(4) || 1.0;

            this.player.style.opacity = 0;
            //300ms delay to allow for the fade to occur
            setTimeout(function () {
                if (parent) {
                    parent.className = parent.className.replace(regexLefty, isRighty ? '' : ' lefty');
                }
                that.player.style.width = scalers.batterX + '%';
                that.player.style.height = scalers.batterY + '%';
                that.player.style.top = (src.indexOf('ipad') === -1 ? 51 : 52) - scalers.batterTop + '%';
                if (isRighty) {
                    that.player.style.right = '';
                    that.player.style.left = 50 - scalers.batterLR + '%';
                } else {
                    that.player.style.left = '';
                    that.player.style.right = (src.indexOf('ipad') === -1 ? 53 : 50) - scalers.batterLR + '%';
                }
                that.player.style.backgroundImage = "url(" + src + ")";
                that.player.style[vendor.transformJS] = "scale(" + bHeight + ")";

                that.player.style.opacity = 1;

            }, 300);
        },
        removePlayerImage : function () {
            // hide image, for whatever reason (no atbat present, pitching sub, etc)
            this.player.style.opacity = 0;
        },
        setGenericPlayerImage : function (src, batter) {
            this.setPlayerImage(src.replace(regexPlayer, "GENERIC-$1-$2$3$4"), batter);
        },
        resize : function(){

        },

        clear : function(){
            this.container.style.opacity=0.1;
            this.container.innerHTML="";
            this.removePlayerImage();
            Array.prototype.forEach.call(document.querySelectorAll('.' + cssClass(pitchFxDataContainerTemplateClassName)), function (node) {
                domHelper.remove(node);
            });
            this.container.style.opacity=1;
        },
        getSizerURI: function (h,w) {
            if(!this.pitchLayer.render || !this.pitchLayer.render.isCanvas){
                return require('../enums/16x11');
            }                
            return this.pitchLayer.render.getSizerURI();
        },
    	anchor	: function(){
            domHelper.append(this.pitchLayer.view,this.sizer);
    		domHelper.append(this.pitchLayer.view,this.player);
    		domHelper.append(this.pitchLayer.view,this.container);
    	},
        destroy : function(){
        	this.clear();

	        domHelper.remove(this.player);
	        domHelper.remove(this.container);
            domHelper.remove(this.sizer);
        }
    };

    return RenderDom;
});
